import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import SweetAlert from "react-bootstrap-sweetalert";
import HippoTable from "../../../components/ReactTable/HipposReactTable";
import TimestampColumn from "components/Custom/TimestampColumn";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import EditButton from "views/Components/EditButton";
import CopyApiKeyButton from "views/Components/CopyApiKeyButton";
import SyncButton from "views/Components/SyncButton";
import DestroyButton from "views/Components/DestroyButton";
import PrintAllButton from "views/Components/PrintAllButton";
import IntegrationsButton from "views/Components/IntegrationsButton";
import DayClosureButton from "views/Components/DayClosureButton";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function StoreListPage() {
  const {
    t,
  } = useTranslation();

  const history = useHistory();
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  const alertSyncData = (storeId) => {
    setIsDisabled(true);
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("messages.synchronizeData")}
        onConfirm={() => syncData(storeId)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="default"
        confirmBtnText={t("common.labels.synchronize")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >{t(
        "messages.doYouWantToSynchronizeTheStoreDataTheServerWillRestartDuringTheProcess",
      )}</SweetAlert>
    );
  };

  const alertDestroyData = (storeId) => {
    setIsDisabled(true);
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title={t("messages.deleteData")}
        onConfirm={() => destroyData(storeId)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="error"
        cancelBtnBsStyle="default"
        confirmBtnText={t("common.actions.delete")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >{t(
        "messages.doYouWantToDeleteTheStoreDataItWillNotBeRecoverable",
      )}</SweetAlert>
    );
  };

  const alertDayClosureData = (storeId) => {
    setIsDisabled(true);
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("messages.dayClosure")}
        onConfirm={() => dayClosureData(storeId)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="default"
        confirmBtnText={t("common.actions.dayClosure")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >{t("messages.doYouWantToCloseTheDayForThisStore")}</SweetAlert>
    );
  };

  const alertPrintAllData = (storeId) => {
    setIsDisabled(true);
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t("messages.printAll")}
        onConfirm={() => printAllData(storeId)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="default"
        confirmBtnText={t("common.actions.print")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >{t("messages.doYouWantToPrintAllPendingDocuments")}</SweetAlert>
    );
  };

  const alertUseIntegrations = (storeId, status) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={status ? t("messages.deactivateBridge") : t("messages.activateBridge")}
        onConfirm={() => toggleIntegrations(storeId, status)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle={status ? "error" : "success"}
        cancelBtnBsStyle="default"
        confirmBtnText={status ? t("common.actions.deactivate") : t("common.actions.activate")}
        cancelBtnText={t("common.actions.cancel")}
        showCancel
      >
        {t("messages.doYouWantToSuffix")}
        {status ? t("messages.deactivateVerb") : t("messages.activateVerb")}
        {t("messages.theStoreBridgesPrefix")}
      </SweetAlert>
    );
  };

  const syncData = (storeId) => {
    apiService
      .patch(`api/v1/stores/${storeId}/sync`)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.synchronizationCompletedSuccessfully"));
        setAlert(null);
        setIsDisabled(false);
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToSynchronize"));
        setAlert(null);
        setIsDisabled(false);
      });
  };

  const destroyData = (storeId) => {
    apiService
      .patch(`api/v1/stores/${storeId}/destroy`)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.deletionCompletedSuccessfully"));
        setAlert(null);
        setIsDisabled(false);
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToDeleteData"));
        setAlert(null);
        setIsDisabled(false);
      });
  };

  const printAllData = (storeId) => {
    apiService
      .patch(`api/v1/stores/${storeId}/print-all`)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.commandSubmittedSuccessfully"));
        setAlert(null);
        setIsDisabled(false);
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToPrintData"));
        setAlert(null);
        setIsDisabled(false);
      });
  };

  const dayClosureData = (storeId) => {
    apiService
      .patch(`api/v1/stores/${storeId}/day-closure`)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.commandSubmittedSuccessfully"));
        setAlert(null);
        setIsDisabled(false);
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToCloseTheDay"));
        setAlert(null);
        setIsDisabled(false);
      });
  };

  const toggleIntegrations = (storeId) => {
    apiService
      .patch(`api/v1/stores/${storeId}/integrations`)
      .then((resp) => {
        notificationService.notifySuccess(t("messages.updateCompletedSuccessfully"));
        setAlert(null);
        fetchData();
      })
      .catch((error) => {
        console.error(error);
        notificationService.notifyError(t("messages.unableToUpdateData"));
        setAlert(null);
      });
  };

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      maxWidth: 70,
      minWidth: 40,
      width: 60,
    },
    {
      Header: t("tables.headers.designation"),
      accessor: "name",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.vatNumber"),
      accessor: "vatNumber",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.phone"),
      accessor: "phone",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.address"),
      accessor: "address",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.createdAt"),
      accessor: "createdAt",
      minWidth: 200,
      maxWidth: 400,
      width: 500,
    },
    {
      Header: "KEEP ALIVE",
      accessor: "lastKeepAlive",
      minWidth: 200,
      maxWidth: 400,
      width: 500,
    },
    {
      Header: "VERSION",
      accessor: "ver",
      minWidth: 70,
      maxWidth: 90,
      width: 80,
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "actions",
      minWidth: 300,
      maxWidth: 300,
      width: 150,
    },
  ];

  const fetchData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get("api/v1/stores");
      setData(attachCustom(dataResponse.data));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.createdAt = <TimestampColumn timestamp={el.createdAt} />;
      el.lastKeepAlive = <TimestampColumn timestamp={el.lastKeepAlive} />;
      el.actions =
        apiService.isSuperAdmin() || apiService.isReseller() ? (
          <div className="actions-right d-flex float-right">
            <CopyApiKeyButton handler={() => handleApiKeyClick(el.apiKey)} />
            <EditButton uri={`/admin/store/${el.id}`} />
            <SyncButton handler={() => alertSyncData(el.id)} disabled={isDisabled} />
            <PrintAllButton handler={() => alertPrintAllData(el.id)} disabled={isDisabled} />
            <DayClosureButton handler={() => alertDayClosureData(el.id)} disabled={isDisabled} />
            <DestroyButton handler={() => alertDestroyData(el.id)} disabled={isDisabled} />
            <IntegrationsButton handler={() => alertUseIntegrations(el.id, el.useIntegrations)} status={el.useIntegrations} />
          </div>
        ) : (
          <div className="actions-right d-flex float-right">
            <SyncButton handler={() => alertSyncData(el.id)} disabled={isDisabled} />
            <PrintAllButton handler={() => alertPrintAllData(el.id)} disabled={isDisabled} />
            <DayClosureButton handler={() => alertDayClosureData(el.id)} disabled={isDisabled} />
            <DestroyButton handler={() => alertDestroyData(el.id)} disabled={isDisabled} />
            <IntegrationsButton handler={() => alertUseIntegrations(el.id, el.useIntegrations)} status={el.useIntegrations} />
          </div>
        );
      el.role = el.role ? el.role.name : "";
      return el;
    });
    return _.sortBy(enhanced, ["order", "id"]);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleApiKeyClick = (storeApiKey) => {
    navigator.clipboard.writeText(storeApiKey);
    notificationService.notifySuccess(t("messages.apiKeyCopiedToClipboard"));
  };

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row>
                  <CreateTableBtn route={"/admin/store"} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default StoreListPage;
